import { Helmet } from "react-helmet";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Avatar,
    Divider,
    Container,
    Grid,
    Paper,
    MenuItem,
    Select,
    Autocomplete,
    TextField
} from "@mui/material";
// import {useTranslation} from "react-i18next";
import { makeStyles } from "@mui/styles";
import Upload from "./UploadImages";
import React, { useState, useEffect } from "react";
import { ReactComponent as TrashIcon } from "../../../../assets/images/trash-alt.svg";
import { useTranslation } from "react-i18next";
import * as Util from "../../../../services/global.service";
import { useFormik } from 'formik';
import profilePhotoService from "../../../../services/profilePhoto.service";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";

const useStyles = makeStyles({
    customAvatarColor: {
        color: "red",
    },
    cardContentHeaderSize: {
        display: "flex",
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        // flexFlow: "row",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    customCardSize: {
        height: 380,
    },
    titleColor: {
        color: "#AAAAAA"
    },
    subTitleColor: {
        color: "#404349",
        paddingTop: "10px",
        wordBreak: "break-all"
    },
    fill: {
        '& > path': {
            fill: "#CC6058"
        },
        '& g > path': {
            fill: "#CC6058"
        },
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    },
    btnDisabled: {
        '& .Mui-disabled': {
            color: "#FFFFFF !important",
            backgroundColor: "#BABABA !important",
        }
    },
    btnDisabledCancel: {
        '& .Mui-disabled': {
            color: "#FFFFFF !important",
            backgroundColor: "#BABABA !important",
            border: "1px solid #BABABA !important"
        }
    },
});
const styles = {
    containerProfile: {
        padding: "22px 25px 40px 24px",
    },
    containerCardContent: {
        paddingTop: "38px"
    }
}
const Profile = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [datas, setDatas] = React.useState({});
    const [employee, setEmployee] = React.useState([]);
    const [photo, setPhoto] = React.useState([]);
    const [status, setStatus] = React.useState(true);
    const language = localStorage.getItem("lang");
    const [edit, setEdit] = React.useState(false);
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (open) {
                setOpen(false)
            }
        }
    }
    const formik = useFormik({
        initialValues: {
            employee: '',
        },
        enableReinitialize: true,
        validationSchema: null,
        onSubmit: (values) => {
            submit(values)
        },
    });
    useEffect(() => {
        getList()
    }, []);
    const getList = () => {
        profilePhotoService.listEmployee().then(
            (response) => {
                setEmployee(Util.formatData(response?.data?.list_employee, []))
            },
        ).catch(() => {
        })
    }
    const submit = (data) => {
        let datas = new FormData();
        if (photo.length > 0) {
            for (let index = 0; index <= photo.length - 1; index++) {
                datas.append("file", photo[index]);
                datas.append("photo", photo[index].name);
            }
        } else {
            datas.append("file", "");
            datas.append("photo", "");
        }
        profilePhotoService.saveData(formik.values.employee.serial, datas).then((rs) => {
            setSuccessAttachmentsText(t("label.uploadSuccessText"))
            setIsSuccessAttachFiles(true)
            getList()
        }).catch((err) => {

        })
    }
    const formikChange = (e) => {
        formik.setFieldValue("employee", e)
        if (e.serial !== undefined && e.serial !== "") {
            profilePhotoService.getDataEmployee(e.serial).then(
                (response) => {
                    setDatas(Util.formatData(response?.data?.employee, {}))
                },
            ).catch(() => {
            })
        } else {
            formik.setFieldValue("employee", '')
            setDatas([])
        }
    }
    const [statusRemove, setStatusRemove] = React.useState(false);
    const [isSuccessAttachFiles, setIsSuccessAttachFiles] = React.useState(false);

    const [successAttachmentsText, setSuccessAttachmentsText] = React.useState("")
    const uploadFileSuccess = (dataFile) => {
        setPhoto(dataFile)
        if (dataFile.length < 1) {
            setStatusRemove(false)
        }
    }
    const removePhoto = () => {
        if (statusRemove === false) {
            setStatusRemove(true)
        }
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        formik.setFieldValue("employee", '')
        setDatas([])
        window.location.reload(true);
    };
    useEffect(() => {
        if (edit === false) {
            if (formik.values.employee !== '') {
                setEdit(true)
            }
        }
    }, [formik.values]);
    const removeImageMain = () => {
        let dataImage = JSON.parse(JSON.stringify(datas))
        dataImage.photo = ''
        setDatas(dataImage)
        setStatusRemove(false)
    };
    const handleDirect = () => {
        setIsSuccessAttachFiles(false)
        window.location.reload(true);
    }
    return (
        <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.end} >{t('admin.label.profilePhoto')}</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                {t('admin.label.profilePhoto')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container spacing={2} mt="20px">
                        <Grid container item >
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper} >
                                    <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", padding: "20px", width: "100%" }}>
                                        <Upload image={datas?.photo} sendFiles={uploadFileSuccess} valueSelect={formik.values.employee} statusRemove={statusRemove} removeImages={removeImageMain}></Upload>
                                        <Box ml="20px" sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flexWrap: "wrap", height: "calc(100% - 130px)" }}>
                                            <Box sx={{ width: "100%", padding: "0 0 10px 0" }}>
                                                <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349">
                                                    {t(`label.employee`)}
                                                </Typography>
                                                <Box pt="7px">
                                                    {/* <Select
                                                        id="workload-select"
                                                        inputlabelprops={{ shrink: false }}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        name="employee"
                                                        defaultValue=""
                                                        displayEmpty
                                                        className="white-bg"
                                                        // onBlur={formik.handleBlur}
                                                        value={formik.values.employee}
                                                        onChange={formikChange}
                                                        getOptionLabel={(option) => option?.fullname}
                                                    >
                                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                                            <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('admin.inputForm.placeholder.employee')} </Typography>
                                                        </MenuItem>
                                                        {
                                                            employee?.length > 0 ?
                                                                employee.map(item => {
                                                                    return (
                                                                        <MenuItem value={item.serial} key={item.serial}>
                                                                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item?.code} {Util.formatData(item?.fullname, false) !== false ? "- " + item?.fullname : ""}</span>
                                                                        </MenuItem>
                                                                    )
                                                                })

                                                                : <MenuItem value="">
                                                                    ---{t('label.notFund')}---
                                                                </MenuItem>
                                                        }
                                                    </Select> */}
                                                    <Autocomplete
                                                        id="country-select-demo"
                                                        options={employee}
                                                        disableCloseOnSelect={false}
                                                        defaultValue=""
                                                        displayEmpty
                                                        name="employee"
                                                        value={formik.values.employee}
                                                        getOptionLabel={(option) => Util.formatData(option.code, "") + `${Util.formatData(option?.code, false) !== false && Util.formatData(option?.fullname, false) !== false ? " - " : ""}` + Util.formatData(option?.fullname, "")}
                                                        onChange={(event, newValue) => {
                                                            formikChange(newValue)
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} sx={{
                                                                position: "relative",
                                                                "::hover": {
                                                                    background: "#000 !important"
                                                                },
                                                                "&:hover": { cursor: "pointer", background: "#5DA196 !important", ".MuiTypography-root": { color: "#fff !important" } }

                                                            }}>
                                                                <Box sx={{ width: "calc(100% - 55px)" }}>
                                                                    <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" color="#404349" sx={{ width: "100%", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>{option?.code} {Util.formatData(option?.fullname, false) !== false ? "- " + option?.fullname : ""}</Typography>
                                                                </Box>
                                                            </Box>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                defaultValue=""
                                                                displayEmpty
                                                                size="small"
                                                                placeholder={t('admin.inputForm.placeholder.employee')}
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                            {formik.values.employee !== undefined && formik.values.employee !== null && formik.values.employee !== "" ?
                                                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flexWrap: "wrap" }} >
                                                    <Box sx={{ width: "40%", padding: "10px 0" }}>
                                                        <Typography fontSize={14} lineHeight="15.4px" className={classes.titleColor}>
                                                            {t(`label.position`)}
                                                        </Typography>
                                                        <Typography fontSize={16} lineHeight="17.6px" fontWeight={500} className={classes.subTitleColor}>
                                                            {language === "en-US" ? Util.formatData(datas?.options?.position_en, "-") : Util.formatData(datas?.options?.position_th, "-")}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: "45%", padding: "10px 0" }}>
                                                        <Typography fontSize={14} lineHeight="15.4px" className={classes.titleColor}>
                                                            {t(`label.team`)}
                                                        </Typography>
                                                        <Typography fontSize={16} lineHeight="17.6px" fontWeight={500} className={classes.subTitleColor}>
                                                            {language === "en-US" ? Util.formatData(datas?.options?.organization_en, "-") : Util.formatData(datas?.options?.organization_th, "-")}
                                                        </Typography>
                                                    </Box>
                                                    {photo.length > 0 || datas?.photo !== "" ?
                                                        <Box sx={{ width: "15%", padding: "10px 0", display: "flex", justifyContent: "flex-end", alignItems: "center", cursor: "pointer" }} onClick={removePhoto} >
                                                            <TrashIcon className={`${classes.fill}`} ></TrashIcon>
                                                            <Typography ml="5px" fontSize={12} lineHeight="17.94px" color="#CC6058">
                                                                {t(`admin.label.removePicture`)}
                                                            </Typography>
                                                        </Box>
                                                        : null
                                                    }
                                                    <Box sx={{ width: "40%", padding: "10px 0" }}>
                                                        <Typography fontSize={14} lineHeight="15.4px" className={classes.titleColor}>
                                                            {t(`admin.inputForm.status`)}
                                                        </Typography>
                                                        <Typography fontSize={16} lineHeight="17.6px" color="#5DA196" sx={{ textTransform: "uppercase", paddingTop: "10px" }}>
                                                            {datas?.status === "active" ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                : null
                                            }
                                        </Box>
                                    </Box>
                                </Paper>
                            </div>

                            <Grid container mt={3} mb={3} >
                                <Grid item xs display="flex" flexDirection="row-reverse">
                                    <Box sx={{ width: "100px" }} className={edit === true ? "" : `${classes.btnDisabled}`}>
                                        <Button onClick={formik.submitForm} color="primary" variant="contained" fullWidth disabled={edit === true ? false : true}>
                                            {t('label.save')}
                                        </Button>
                                    </Box>
                                    <Box mr={2} sx={{ width: "100px" }} className={formik.values.employee !== undefined && formik.values.employee !== null && formik.values.employee !== "" ? "" : `${classes.btnDisabledCancel}`}>
                                        <Button color="black" variant="outlined" fullWidth onClick={handleCancel} disabled={formik.values.employee !== undefined && formik.values.employee !== null && formik.values.employee !== "" ? false : true} >
                                            {t('label.cancel')}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <MessageDialog open={isSuccessAttachFiles} page={true} doDirect={() => handleDirect()} setValue={() => setIsSuccessAttachFiles(false)} title={t("label.success")} text={successAttachmentsText} />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />
                </Container>
            </Box>
        </Box >
    );
};
export default Profile;
